import axios from 'axios';

// Определяем базовый URL API
const getApiBaseUrl = () => {
  // В продакшене API находится на том же домене
  if (window.location.hostname === 'backtest.wyckoffpro.ru' || 
      window.location.hostname === 'www.backtest.wyckoffpro.ru') {
    return '/api';  // Без trailing slash - axios добавит его сам при необходимости
  }
  // В разработке используем переменную окружения или дефолт
  return process.env.REACT_APP_API_URL || 'http://localhost:8000/api';
};

const API_BASE_URL = getApiBaseUrl();

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default apiClient;

